/**
 * Another clever approach of writing reducers:
 *
 * export default function(state = initialState, action) {
 *   const actions = {
 *      [ACTION_TYPE]: () => [action.payload.data, ...state]
 *   };
 *
 *   return (_.isFunction(actions[action.type])) ? actions[action.type]() : state
 * }
 */

import * as types from '../constants/ActionTypes';

const initialState = null;

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SET_CURRENT_SECTION:
      return action.section;
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/currentSection.js
 **/